var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('div',{attrs:{"id":"divTable"}},[_c('div',{attrs:{"id":"divTableBody"}},_vm._l((_vm.mapping),function(m){return _c('div',{key:m.key,attrs:{"id":"divTableRow"}},[_c('tree',{attrs:{"label":m.header,"nodes":_vm.data[m.key]}})],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }